import React, { useState, useEffect, useRef } from "react";
import axios from "../utils/axiosInstance";
import {
  Modal, Button, Form, Row, Col, Card, Badge,
  Spinner, Alert, InputGroup, Pagination,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { getApiBase } from "../utils/useApiBase";
const API_URL = `${getApiBase()}/uburezi`;

const Uburezi = ({ isUmudugudu = false }) => {
  const [uburezi, setUburezi] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", variant: "" });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterLevel, setFilterLevel] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [stats, setStats] = useState({
    total: 0, ntagoYize: 0, abanza: 0, ayisumbuye: 0, kaminuza: 0,
  });
  const [form, setForm] = useState({
    urwego_rw_amashuri: "", umwuga: "",
    ishuri_yizemo: "", amazina_y_umuturage: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [editId, setEditId] = useState(null);

  // ─── Responsive States ──────────────────────────────────
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [windowHeight, setWindowHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 800
  );
  const [orientation, setOrientation] = useState(
    typeof window !== "undefined" && window.innerWidth > window.innerHeight
      ? "landscape" : "portrait"
  );
  const [useCardView, setUseCardView] = useState(false);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  const topRef = useRef(null);

  // ─── Breakpoints ────────────────────────────────────────
  const isExtraSmall = windowWidth <= 360;
  const isSmall = windowWidth <= 576;
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;
  const isDesktop = windowWidth > 1024;
  const isLandscape = orientation === "landscape";
  const isShortScreen = windowHeight <= 500;

  // ─── Theme ──────────────────────────────────────────────
  const theme = {
    bg: "#f0f4f8", bgSecondary: "#eef3fb", card: "#ffffff",
    text: "#374151", textBright: "#0d1b2a", muted: "#64748b",
    primary: "#0B3D91", primaryGlow: "rgba(11,61,145,0.18)",
    success: "#16a34a", successGlow: "rgba(22,163,74,0.18)",
    warning: "#d97706", warningGlow: "rgba(217,119,6,0.18)",
    danger: "#dc2626", dangerGlow: "rgba(220,38,38,0.18)",
    info: "#0369a1", infoGlow: "rgba(3,105,161,0.18)",
    border: "#e2e8f0", borderLight: "#f1f5f9",
    gradient1: "linear-gradient(135deg, #0B3D91 0%, #093278 100%)",
    gradient2: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    gradient3: "linear-gradient(135deg, #0369a1 0%, #075985 100%)",
    gradient4: "linear-gradient(135deg, #d97706 0%, #b45309 100%)",
  };

  const educationLevels = [
    { value: "Ntago yize", label: "Ntago yize", icon: "x-circle-fill", color: "danger" },
    { value: "Abanza", label: "Abanza", icon: "book-fill", color: "primary" },
    { value: "Ayisumbuye", label: "Ayisumbuye", icon: "mortarboard-fill", color: "info" },
    { value: "Kaminuza", label: "Kaminuza", icon: "trophy-fill", color: "success" },
    { value: "masitazi", label: "Masitazi", icon: "trophy-fill", color: "success" },
    { value: "dogitora", label: "Dogitora", icon: "trophy-fill", color: "success" },
    { value: "imyuga", label: "Imyuga", icon: "tools", color: "warning" },
  ];

  const getLevelConfig = (level) =>
    educationLevels.find((l) => l.value === level) || educationLevels[0];

  const getLevelColor = (colorName) => {
    const map = {
      danger: theme.danger, primary: "#818cf8",
      info: theme.info, success: theme.success, warning: theme.warning,
    };
    return map[colorName] || theme.muted;
  };

  const getLevelBg = (colorName) => {
    const map = {
      danger: "rgba(255,61,113,0.12)", primary: "rgba(129,140,248,0.12)",
      info: "rgba(0,149,255,0.12)", success: "rgba(0,214,143,0.12)",
      warning: "rgba(255,170,0,0.12)",
    };
    return map[colorName] || "rgba(255,255,255,0.05)";
  };

  // ─── Responsive Detection ──────────────────────────────
  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      setWindowWidth(w);
      setWindowHeight(h);
      setOrientation(w > h ? "landscape" : "portrait");
      if (w <= 576) { setItemsPerPage(5); setUseCardView(true); }
      else if (w <= 768) { setItemsPerPage(6); setUseCardView(true); }
      else { setItemsPerPage(8); setUseCardView(false); }
    };
    const handleOrientationChange = () => setTimeout(handleResize, 150);
    const handleFocusIn = (e) => {
      if (["INPUT", "TEXTAREA", "SELECT"].includes(e.target.tagName))
        if (window.innerWidth <= 768) setKeyboardVisible(true);
    };
    const handleFocusOut = () => setKeyboardVisible(false);
    const handleViewportResize = () => {
      if (window.visualViewport)
        setKeyboardVisible(window.visualViewport.height < window.innerHeight * 0.75);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);
    if (window.visualViewport)
      window.visualViewport.addEventListener("resize", handleViewportResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
      if (window.visualViewport)
        window.visualViewport.removeEventListener("resize", handleViewportResize);
    };
  }, []);

  // ─── Viewport Setup ────────────────────────────────────
  useEffect(() => {
    let vp = document.querySelector('meta[name="viewport"]');
    if (!vp) { vp = document.createElement("meta"); vp.name = "viewport"; document.head.appendChild(vp); }
    vp.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover";
    let tc = document.querySelector('meta[name="theme-color"]');
    if (!tc) { tc = document.createElement("meta"); tc.name = "theme-color"; document.head.appendChild(tc); }
    tc.content = theme.bg;
    
    document.body.style.backgroundColor = theme.bg;
    return () => { document.body.style.overscrollBehavior = ""; };
  }, []);

  // ────────────────────────────────────────────────
  // Data Logic
  // ────────────────────────────────────────────────
  const calculateStats = (data) => {
    setStats({
      total: data.length,
      ntagoYize: data.filter(i => i.urwego_rw_amashuri === "Ntago yize").length,
      abanza: data.filter(i => i.urwego_rw_amashuri === "Abanza").length,
      ayisumbuye: data.filter(i => i.urwego_rw_amashuri === "Ayisumbuye").length,
      kaminuza: data.filter(i => i.urwego_rw_amashuri === "Kaminuza").length,
    });
  };

  const showAlertMessage = (msg, variant = "success") => {
    setAlert({ show: true, message: msg, variant });
    setTimeout(() => setAlert({ show: false, message: "", variant: "" }), 4500);
  };

  const fetchUburezi = async () => {
    setLoading(true);
    try {
      const url = isUmudugudu
        ? `${getApiBase()}/umudugudu/module-data/uburezi`
        : API_URL;
      const res = await axios.get(url);
      const data = Array.isArray(res.data) ? res.data : (res.data?.data ?? res.data?.uburezi ?? []);
      setUburezi(data); setFilteredData(data); calculateStats(data);
    } catch { showAlertMessage("Habaye ikosa mu kugira amakuru y'uburezi", "danger"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchUburezi(); }, []);

  useEffect(() => {
    let result = [...uburezi];
    if (searchTerm) {
      const t = searchTerm.toLowerCase();
      result = result.filter(i =>
        i.amazina_y_umuturage?.toLowerCase().includes(t) ||
        i.umwuga?.toLowerCase().includes(t) ||
        i.ishuri_yizemo?.toLowerCase().includes(t)
      );
    }
    if (filterLevel !== "all") result = result.filter(i => i.urwego_rw_amashuri === filterLevel);
    setFilteredData(result); setCurrentPage(1);
  }, [searchTerm, filterLevel, uburezi]);

  const idxLast = currentPage * itemsPerPage;
  const idxFirst = idxLast - itemsPerPage;
  const current = filteredData.slice(idxFirst, idxLast);
  const totalPg = Math.ceil(filteredData.length / itemsPerPage);

  const paginate = (n) => {
    setCurrentPage(n);
    if (topRef.current && isMobile) topRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const validateForm = () => {
    const errors = {};
    if (!form.urwego_rw_amashuri) errors.urwego_rw_amashuri = "Hitamo urwego rw'amashuri";
    if (!form.amazina_y_umuturage?.trim()) errors.amazina_y_umuturage = "Amazina ni ngombwa";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (formErrors[name]) setFormErrors({ ...formErrors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return showAlertMessage("Uzuza neza amakuru!", "warning");
    try {
      if (editing) {
        await axios.put(`${API_URL}/${editId}`, form);
        showAlertMessage("Amakuru yavuguruwe neza!", "success");
      } else {
        await axios.post(API_URL, form);
        showAlertMessage("Amakuru yashyizwemo neza!", "success");
      }
      resetForm(); setShow(false); fetchUburezi();
      if (navigator.vibrate) navigator.vibrate(100);
    } catch { showAlertMessage("Ntibikunze kubika!", "danger"); }
  };

  const resetForm = () => {
    setForm({ urwego_rw_amashuri: "", umwuga: "", ishuri_yizemo: "", amazina_y_umuturage: "" });
    setFormErrors({}); setEditing(false); setEditId(null);
  };

  const handleAdd = () => { resetForm(); setShow(true); };
  const handleEdit = (item) => {
    setForm({
      urwego_rw_amashuri: item.urwego_rw_amashuri,
      umwuga: item.umwuga || "", ishuri_yizemo: item.ishuri_yizemo || "",
      amazina_y_umuturage: item.amazina_y_umuturage,
    });
    setEditId(item.uburezi_id); setEditing(true); setFormErrors({}); setShow(true);
  };
  const handleViewDetails = (item) => { setSelectedItem(item); setShowDetails(true); };
  const handleDeleteClick = (item) => { setDeleteTarget(item); setShowDeleteModal(true); };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      await axios.delete(`${API_URL}/${deleteTarget.uburezi_id}`);
      showAlertMessage("Amakuru yasibwe neza!", "success"); fetchUburezi();
    } catch { showAlertMessage("Ntibikunze gusiba!", "danger"); }
    finally { setDeleting(false); setShowDeleteModal(false); setDeleteTarget(null); }
  };

  const exportToCSV = () => {
    const headers = ["Amazina", "Urwego", "Umwuga", "Ishuri"];
    const csvData = filteredData.map(i => [i.amazina_y_umuturage, i.urwego_rw_amashuri, i.umwuga || "-", i.ishuri_yizemo || "-"]);
    const csv = [headers, ...csvData].map(r => r.join(",")).join("\n");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
    link.download = `uburezi_${new Date().toISOString().split("T")[0]}.csv`;
    link.click(); showAlertMessage("Dosiye yakoboye neza!", "success");
  };

  const activeFilterCount = filterLevel !== "all" ? 1 : 0;
  const clearFilters = () => { setSearchTerm(""); setFilterLevel("all"); };

  // ─── Responsive Values ─────────────────────────────────
  const containerPadding = isExtraSmall ? "0.5rem" : isSmall ? "0.65rem" : isMobile ? "0.85rem" : "1.5rem";
  const headerFontSize = isExtraSmall ? "0.95rem" : isSmall ? "1.05rem" : isMobile ? "1.2rem" : "1.65rem";
  const statValueSize = isExtraSmall ? "1.3rem" : isSmall ? "1.5rem" : isMobile ? "1.7rem" : "2.4rem";
  const statTitleSize = isExtraSmall ? "0.55rem" : isSmall ? "0.6rem" : isMobile ? "0.7rem" : "0.85rem";

  const statCards = [
    { title: isSmall ? "Bose" : "Abaturage Bose", val: stats.total, gradient: theme.gradient1, glowColor: theme.primaryGlow, icon: "people-fill", iconColor: "#a5b4fc", percent: 100 },
    { title: "Kaminuza", val: stats.kaminuza, gradient: theme.gradient2, glowColor: theme.successGlow, icon: "trophy-fill", iconColor: "#6ee7b7", percent: stats.total ? Math.round((stats.kaminuza / stats.total) * 100) : 0 },
    { title: isSmall ? "Ayisum." : "Ayisumbuye", val: stats.ayisumbuye, gradient: theme.gradient3, glowColor: theme.infoGlow, icon: "mortarboard-fill", iconColor: "#7dd3fc", percent: stats.total ? Math.round((stats.ayisumbuye / stats.total) * 100) : 0 },
    { title: "Abanza", val: stats.abanza, gradient: theme.gradient4, glowColor: theme.warningGlow, icon: "book-fill", iconColor: "#fcd34d", percent: stats.total ? Math.round((stats.abanza / stats.total) * 100) : 0 },
  ];

  // ────────────────────────────────────────────────
  // Mobile Card Renderer
  // ────────────────────────────────────────────────
  const renderMobileCard = (item, idx) => {
    const level = getLevelConfig(item.urwego_rw_amashuri);
    const lColor = getLevelColor(level.color);
    const lBg = getLevelBg(level.color);

    return (
      <div key={item.uburezi_id} style={{
        background: theme.card, border: `1px solid ${theme.border}`,
        borderRadius: isExtraSmall ? "12px" : "16px",
        padding: isExtraSmall ? "0.6rem" : "0.85rem",
        marginBottom: "0.6rem", WebkitTapHighlightColor: "transparent",
      }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start" style={{ marginBottom: "0.5rem" }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="d-flex align-items-center gap-2" style={{ marginBottom: "0.2rem" }}>
              <div style={{
                width: isExtraSmall ? "28px" : "32px", height: isExtraSmall ? "28px" : "32px",
                borderRadius: "8px", background: `${theme.primary}22`,
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
              }}>
                <i className="bi bi-person-fill" style={{ color: theme.primary, fontSize: "0.8rem" }}></i>
              </div>
              <div style={{
                fontWeight: 700, fontSize: isExtraSmall ? "0.82rem" : "0.9rem",
                color: theme.textBright, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              }}>{item.amazina_y_umuturage}</div>
            </div>
            <div className="d-flex gap-1 flex-wrap" style={{ marginLeft: isExtraSmall ? "36px" : "40px" }}>
              <span style={{
                display: "inline-flex", alignItems: "center", gap: "0.25rem",
                padding: "0.2rem 0.6rem", borderRadius: "12px",
                fontSize: isExtraSmall ? "0.58rem" : "0.65rem", fontWeight: 600,
                color: lColor, background: lBg,
                border: `1px solid ${lColor}33`,
              }}>
                <i className={`bi bi-${level.icon}`}></i>
                {item.urwego_rw_amashuri}
              </span>
            </div>
          </div>
          <span style={{ color: "#52525b", fontSize: "0.6rem", flexShrink: 0, marginLeft: "0.3rem" }}>
            #{idxFirst + idx + 1}
          </span>
        </div>

        {/* Info Grid */}
        <div style={{
          display: "grid", gridTemplateColumns: "1fr 1fr",
          gap: isExtraSmall ? "0.25rem" : "0.35rem", marginBottom: "0.5rem",
        }}>
          <div style={{ background: theme.bgSecondary, borderRadius: "8px", padding: "0.4rem", border: `1px solid ${theme.border}` }}>
            <div style={{ fontSize: "0.5rem", color: theme.muted, textTransform: "uppercase", letterSpacing: "0.3px", marginBottom: "0.1rem" }}>Umwuga</div>
            <div style={{ fontSize: isExtraSmall ? "0.68rem" : "0.73rem", color: item.umwuga ? theme.text : theme.muted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {item.umwuga || "—"}
            </div>
          </div>
          <div style={{ background: theme.bgSecondary, borderRadius: "8px", padding: "0.4rem", border: `1px solid ${theme.border}` }}>
            <div style={{ fontSize: "0.5rem", color: theme.muted, textTransform: "uppercase", letterSpacing: "0.3px", marginBottom: "0.1rem" }}>Ishuri</div>
            <div style={{ fontSize: isExtraSmall ? "0.68rem" : "0.73rem", color: item.ishuri_yizemo ? theme.text : theme.muted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {item.ishuri_yizemo || "—"}
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="d-flex gap-2" style={{ borderTop: `1px solid ${theme.border}`, paddingTop: "0.5rem" }}>
          {[
            { icon: "eye", label: "Reba", color: theme.info, borderColor: "rgba(0,149,255,0.3)", bg: "rgba(0,149,255,0.08)", action: () => handleViewDetails(item) },
            { icon: "pencil", label: "Hindura", color: theme.primary, borderColor: "rgba(108,99,255,0.3)", bg: "rgba(108,99,255,0.08)", action: () => handleEdit(item) },
            { icon: "trash", label: "Siba", color: theme.danger, borderColor: "rgba(255,61,113,0.3)", bg: "rgba(255,61,113,0.08)", action: () => handleDeleteClick(item) },
          ].map((btn, i) => (
            <button key={i} onClick={btn.action} className="flex-fill" style={{
              borderRadius: "10px", fontSize: isExtraSmall ? "0.63rem" : "0.68rem",
              minHeight: "34px", border: `1px solid ${btn.borderColor}`,
              color: btn.color, background: btn.bg, cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", gap: "0.25rem",
              fontWeight: 600, WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
            }}>
              <i className={`bi bi-${btn.icon}`}></i>
              {!isExtraSmall && btn.label}
            </button>
          ))}
        </div>
      </div>
    );
  };

  // ────────────────────────────────────────────────
  // Responsive Pagination
  // ────────────────────────────────────────────────
  const renderPagination = () => {
    if (totalPg <= 1) return null;
    const maxVis = isExtraSmall ? 3 : isSmall ? 3 : isMobile ? 5 : 7;
    let startP = Math.max(1, currentPage - Math.floor(maxVis / 2));
    let endP = Math.min(totalPg, startP + maxVis - 1);
    if (endP - startP + 1 < maxVis) startP = Math.max(1, endP - maxVis + 1);
    const pages = [];
    for (let i = startP; i <= endP; i++) pages.push(i);

    return (
      <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "0.75rem", gap: "0.5rem" }}>
        <small style={{ color: theme.muted, fontSize: isSmall ? "0.63rem" : "0.78rem" }}>
          {idxFirst + 1}–{Math.min(idxLast, filteredData.length)} kuri {filteredData.length}
        </small>
        <div className="d-flex gap-1">
          {[
            { icon: "chevron-left", action: () => paginate(currentPage - 1), disabled: currentPage === 1 },
            ...pages.map(p => ({ label: p, action: () => paginate(p), active: p === currentPage })),
            { icon: "chevron-right", action: () => paginate(currentPage + 1), disabled: currentPage === totalPg },
          ].map((btn, idx) => (
            <button key={idx} onClick={btn.action} disabled={btn.disabled} style={{
              width: isMobile ? "34px" : "38px", height: isMobile ? "34px" : "38px",
              borderRadius: "10px",
              border: btn.active ? "none" : `1px solid ${theme.border}`,
              background: btn.active ? theme.primary : "transparent",
              color: btn.active ? "#fff" : btn.disabled ? theme.border : theme.muted,
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: btn.disabled ? "not-allowed" : "pointer",
              fontSize: isSmall ? "0.7rem" : "0.82rem", fontWeight: btn.active ? 700 : 500,
              boxShadow: btn.active ? `0 4px 15px ${theme.primaryGlow}` : "none",
              WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
            }}>
              {btn.icon ? <i className={`bi bi-${btn.icon}`}></i> : btn.label}
            </button>
          ))}
        </div>
      </div>
    );
  };

  // ────────────────────────────────────────────────
  // JSX
  // ────────────────────────────────────────────────
  return (
    <div ref={topRef} style={{
      background: theme.bg, color: theme.text, minHeight: "100vh",
      padding: containerPadding,
      paddingTop: isMobile ? `max(${containerPadding}, env(safe-area-inset-top, 0px))` : containerPadding,
      paddingBottom: isMobile ? `max(${containerPadding}, env(safe-area-inset-bottom, 0px))` : containerPadding,
      fontFamily: "'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      WebkitOverflowScrolling: "touch", overflowX: "hidden",
    }}>

      {/* ═══════════ RESPONSIVE STYLES ═══════════ */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800&display=swap');
        * { -webkit-text-size-adjust: 100%; text-size-adjust: 100%; box-sizing: border-box; }
        html, body {  }

        .modal-content {
          background: ${theme.bg} !important; border: 1px solid ${theme.border} !important;
          border-radius: ${isMobile ? "16px" : "20px"} !important; overflow: hidden;
          box-shadow: 0 25px 80px rgba(0,0,0,0.6) !important;
          margin: ${isMobile ? "0.5rem" : "auto"};
          max-height: ${isMobile ? "92vh" : "auto"};
        }
        .modal-header .btn-close { filter: invert(1) grayscale(100%) brightness(200%); }
        .modal-header {
          padding: ${isSmall ? "0.75rem 1rem" : "1.25rem 1.5rem"} !important;
        }
        .modal-body {
          padding: ${isSmall ? "0.75rem" : isMobile ? "1rem" : "2rem"} !important;
          overflow-y: auto; -webkit-overflow-scrolling: touch;
          max-height: ${isMobile ? "65vh" : "auto"};
        }
        .modal-footer {
          padding: ${isSmall ? "0.5rem 0.75rem" : "1rem 1.5rem"} !important;
          flex-wrap: wrap; gap: 0.5rem;
        }
        .modal-title { font-size: ${isSmall ? "0.88rem" : isMobile ? "1rem" : "1.2rem"} !important; }

        .form-control, .form-select {
          background: ${theme.card} !important; border: 1px solid ${theme.border} !important;
          color: ${theme.text} !important; border-radius: 12px !important;
          padding: ${isSmall ? "0.55rem 0.7rem" : "0.7rem 1rem"} !important;
          font-size: 16px !important; min-height: ${isMobile ? "44px" : "auto"};
          -webkit-appearance: none; appearance: none;
        }
        .form-control:focus, .form-select:focus {
          box-shadow: 0 0 0 3px ${theme.primaryGlow} !important;
          border-color: ${theme.primary} !important;
        }
        .form-control::placeholder { color: ${theme.muted} !important; opacity: 0.6; }
        .form-select option { background: ${theme.card}; color: ${theme.text}; }
        .form-label {
          color: ${theme.muted} !important; font-weight: 500 !important;
          margin-bottom: 0.4rem !important; font-size: ${isSmall ? "0.78rem" : "0.88rem"} !important;
        }
        .input-group-text {
          background: ${theme.bgSecondary} !important; border-color: ${theme.border} !important;
          color: ${theme.muted} !important;
        }
        .alert { border-radius: ${isSmall ? "10px" : "14px"} !important; border: none !important;
          font-size: ${isSmall ? "0.78rem" : "0.88rem"} !important; }

        .mobile-filter-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,0.6); z-index: 1055;
          opacity: ${showMobileFilters ? 1 : 0};
          pointer-events: ${showMobileFilters ? "auto" : "none"};
          transition: opacity 0.3s ease;
        }
        .mobile-filter-panel {
          position: fixed; bottom: 0; left: 0; right: 0;
          background: ${theme.card}; border-top: 1px solid ${theme.border};
          border-radius: 20px 20px 0 0; padding: 1.25rem;
          padding-bottom: max(1.25rem, env(safe-area-inset-bottom, 0px));
          z-index: 1060;
          transform: translateY(${showMobileFilters ? "0" : "100%"});
          transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
          box-shadow: 0 -10px 40px rgba(0,0,0,0.5);
          max-height: 70vh; overflow-y: auto; -webkit-overflow-scrolling: touch;
        }

        @supports (padding: max(0px)) {
          .safe-pad { padding-left: max(0px, env(safe-area-inset-left)); padding-right: max(0px, env(safe-area-inset-right)); }
        }
        @media (hover: none) {
          button:active, .btn:active { opacity: 0.8 !important; transform: scale(0.97) !important; }
        }
        @media (max-width: 280px) {
          .modal-body { padding: 0.4rem !important; }
          button { font-size: 0.63rem !important; }
        }
        @media (max-height: 500px) and (orientation: landscape) {
          .stat-icon-ring { display: none !important; }
        }
        @media (prefers-reduced-motion: reduce) {
          * { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
        }
        @media print {
          body { background: white !important; color: black !important; }
          .btn, button { display: none !important; }
        }
        ::-webkit-scrollbar { width: ${isMobile ? "0" : "8px"}; height: ${isMobile ? "0" : "8px"}; }
        ::-webkit-scrollbar-track { background: ${theme.bg}; }
        ::-webkit-scrollbar-thumb { background: ${theme.borderLight}; border-radius: 4px; }
        @media (pointer: coarse) { button, .btn, select, input { min-height: 44px; } }
        @keyframes pulse-danger {
          0% { box-shadow: 0 0 0 0 rgba(255,61,113,0.4); }
          70% { box-shadow: 0 0 0 12px rgba(255,61,113,0); }
          100% { box-shadow: 0 0 0 0 rgba(255,61,113,0); }
        }
      `}</style>

      {/* ═══════════ HEADER ═══════════ */}
      <div className="d-flex justify-content-between align-items-start flex-wrap"
        style={{ marginBottom: isMobile ? "0.75rem" : "1.5rem", gap: "0.5rem" }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2 className="fw-bold mb-1" style={{ color: theme.textBright, fontSize: headerFontSize, letterSpacing: "-0.02em", lineHeight: 1.3 }}>
            <i className="bi bi-mortarboard-fill me-2" style={{ color: theme.primary }}></i>
            {isExtraSmall ? "Uburezi" : "Uburezi bw'Abaturage"}
          </h2>
          {!isShortScreen && (
            <small style={{ color: theme.muted, fontSize: isSmall ? "0.65rem" : "0.82rem", display: "block" }}>
              {isSmall ? "Gucunga uburezi" : "Gucunga no gukurikirana amakuru y'uburezi bw'abaturage"}
            </small>
          )}
        </div>
        <div className="d-flex gap-2 flex-shrink-0">
          <button onClick={handleAdd} style={{
            background: theme.primary, border: "none", borderRadius: isSmall ? "10px" : "12px",
            padding: isSmall ? "0.45rem 0.7rem" : "0.6rem 1.2rem", fontWeight: 600,
            color: "#fff", fontSize: isSmall ? "0.78rem" : "0.88rem",
            boxShadow: `0 4px 20px ${theme.primaryGlow}`,
            minHeight: isMobile ? "44px" : "auto", cursor: "pointer",
            WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
            display: "flex", alignItems: "center", gap: "0.35rem",
          }}>
            <i className="bi bi-plus-circle"></i>
            {isExtraSmall ? "" : isSmall ? "Ongeraho" : "Ongeraho"}
          </button>
          <button onClick={fetchUburezi} style={{
            background: "transparent", border: `1px solid ${theme.borderLight}`,
            borderRadius: "12px", color: theme.text, padding: "0.5rem",
            minWidth: isMobile ? "40px" : "auto", minHeight: isMobile ? "40px" : "auto",
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
            WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
          }}>
            <i className="bi bi-arrow-clockwise"></i>
          </button>
          <button onClick={exportToCSV} style={{
            background: "transparent", border: `1px solid ${theme.borderLight}`,
            borderRadius: "12px", color: theme.success, padding: "0.5rem",
            minWidth: isMobile ? "40px" : "auto", minHeight: isMobile ? "40px" : "auto",
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.3rem",
            fontWeight: 600, fontSize: isSmall ? "0.75rem" : "0.85rem",
            WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
          }}>
            <i className="bi bi-download"></i>
            {!isSmall && "Excel"}
          </button>
        </div>
      </div>

      {/* ═══════════ ALERT ═══════════ */}
      {alert.show && (
        <Alert variant={alert.variant} dismissible onClose={() => setAlert({ show: false })} className="mb-3 shadow"
          style={{
            position: isMobile ? "fixed" : "relative",
            top: isMobile ? "max(0.5rem, env(safe-area-inset-top, 0px))" : "auto",
            left: isMobile ? "0.5rem" : "auto", right: isMobile ? "0.5rem" : "auto",
            zIndex: isMobile ? 1100 : "auto", margin: isMobile ? 0 : undefined,
          }}>
          {alert.message}
        </Alert>
      )}

      {/* ═══════════ STATS ═══════════ */}
      <Row className="mb-3" style={{ rowGap: isSmall ? "0.35rem" : "0.75rem" }}>
        {statCards.map((s, i) => (
          <Col key={i} xs={6} lg={3} className="mb-1 mb-lg-0">
            <div style={{
              background: theme.card, borderRadius: isSmall ? "14px" : "20px",
              padding: isExtraSmall ? "0.6rem" : isSmall ? "0.8rem" : isMobile ? "1rem" : "1.5rem",
              border: `1px solid ${theme.border}`, position: "relative", overflow: "hidden",
            }}>
              <div style={{
                position: "absolute", top: "-20px", right: "-20px",
                width: isSmall ? "60px" : "100px", height: isSmall ? "60px" : "100px",
                borderRadius: "50%", background: s.gradient, opacity: 0.1, filter: "blur(20px)",
              }} />

              {!(isShortScreen && isLandscape) && (
                <div className="stat-icon-ring d-flex align-items-start justify-content-between" style={{ marginBottom: isSmall ? "0.35rem" : "0.6rem" }}>
                  <div style={{
                    width: isExtraSmall ? "32px" : isSmall ? "38px" : "48px",
                    height: isExtraSmall ? "32px" : isSmall ? "38px" : "48px",
                    borderRadius: isSmall ? "10px" : "14px", background: s.gradient,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    boxShadow: `0 6px 20px ${s.glowColor}`,
                  }}>
                    <i className={`bi bi-${s.icon}`} style={{ fontSize: isExtraSmall ? "0.85rem" : isSmall ? "1rem" : "1.3rem", color: "#fff" }}></i>
                  </div>
                  <span style={{
                    background: "rgba(255,255,255,0.06)", borderRadius: "15px",
                    padding: "0.15rem 0.5rem", fontSize: isExtraSmall ? "0.55rem" : "0.68rem",
                    fontWeight: 700, color: s.iconColor,
                  }}>{s.percent}%</span>
                </div>
              )}

              <div style={{ fontSize: statValueSize, fontWeight: 800, color: theme.textBright, lineHeight: 1.1, letterSpacing: "-0.03em" }}>
                {s.val.toLocaleString()}
              </div>
              <div style={{ color: theme.muted, fontSize: statTitleSize, fontWeight: 500, marginTop: "0.1rem" }}>
                {s.title}
              </div>

              {!isExtraSmall && (
                <div style={{ marginTop: isSmall ? "0.35rem" : "0.6rem", height: "3px", borderRadius: "3px", background: "rgba(255,255,255,0.06)", overflow: "hidden" }}>
                  <div style={{ height: "100%", width: `${s.percent}%`, borderRadius: "3px", background: s.gradient, transition: "width 1s ease" }} />
                </div>
              )}
            </div>
          </Col>
        ))}
      </Row>

      {/* ═══════════ FILTERS ═══════════ */}
      <div style={{
        background: theme.card, borderRadius: isSmall ? "12px" : "16px",
        padding: isSmall ? "0.6rem" : isMobile ? "0.75rem" : "1.25rem",
        border: `1px solid ${theme.border}`, marginBottom: isMobile ? "0.75rem" : "1.25rem",
      }}>
        {isMobile ? (
          <div>
            <div className="d-flex gap-2">
              <InputGroup style={{ flex: 1 }}>
                <InputGroup.Text style={{ borderRadius: "12px 0 0 12px", padding: "0.35rem 0.5rem" }}>
                  <i className="bi bi-search"></i>
                </InputGroup.Text>
                <Form.Control placeholder="Shakisha..." value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  style={{ borderRadius: "0 12px 12px 0" }} />
              </InputGroup>
              <button onClick={() => setShowMobileFilters(true)} style={{
                background: "transparent", border: `1px solid ${activeFilterCount > 0 ? theme.primary : theme.borderLight}`,
                borderRadius: "12px", color: activeFilterCount > 0 ? theme.primary : theme.muted,
                minWidth: "44px", minHeight: "44px", cursor: "pointer", position: "relative",
                display: "flex", alignItems: "center", justifyContent: "center",
                WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
              }}>
                <i className="bi bi-funnel"></i>
                {activeFilterCount > 0 && (
                  <span style={{
                    position: "absolute", top: "-4px", right: "-4px",
                    background: theme.danger, color: "#fff", borderRadius: "50%",
                    width: "16px", height: "16px", fontSize: "0.58rem",
                    display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700,
                  }}>{activeFilterCount}</span>
                )}
              </button>
              {!isExtraSmall && (
                <button onClick={() => setUseCardView(!useCardView)} style={{
                  background: "transparent", border: `1px solid ${theme.borderLight}`,
                  borderRadius: "12px", color: theme.muted, minWidth: "44px", minHeight: "44px",
                  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                  WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
                }}>
                  <i className={`bi bi-${useCardView ? "table" : "grid-3x3-gap"}`}></i>
                </button>
              )}
            </div>
            {activeFilterCount > 0 && (
              <div className="d-flex gap-1 flex-wrap mt-2">
                <Badge pill style={{ cursor: "pointer", fontSize: "0.58rem", background: `${theme.primary}22`, color: theme.primary, border: `1px solid ${theme.primary}44` }}
                  onClick={() => setFilterLevel("all")}>
                  {filterLevel} ✕
                </Badge>
                <Badge pill bg="secondary" style={{ cursor: "pointer", fontSize: "0.58rem" }} onClick={clearFilters}>
                  Siba byose ✕
                </Badge>
              </div>
            )}
          </div>
        ) : (
          <Row className="g-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ borderRadius: "12px 0 0 12px" }}>
                  <i className="bi bi-search"></i>
                </InputGroup.Text>
                <Form.Control placeholder="Shakisha amazina, umwuga, ishuri..."
                  value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
                  style={{ borderRadius: "0 12px 12px 0" }} />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Select value={filterLevel} onChange={e => setFilterLevel(e.target.value)}
                style={{ borderRadius: "12px" }}>
                <option value="all">Urwego rwose</option>
                {educationLevels.map(l => <option key={l.value} value={l.value}>{l.label}</option>)}
              </Form.Select>
            </Col>
            <Col md={2}>
              {activeFilterCount > 0 && (
                <button onClick={clearFilters} style={{
                  background: "transparent", border: `1px solid ${theme.danger}44`,
                  borderRadius: "12px", color: theme.danger, width: "100%",
                  minHeight: "44px", cursor: "pointer", fontWeight: 600, fontSize: "0.82rem",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "0.3rem",
                }}>
                  <i className="bi bi-x-lg"></i>Siba
                </button>
              )}
            </Col>
          </Row>
        )}
        {(searchTerm || filterLevel !== "all") && (
          <div className="mt-2">
            <small style={{ color: theme.muted, fontSize: isSmall ? "0.63rem" : "0.78rem" }}>
              <i className="bi bi-info-circle me-1"></i>
              Byasanze: <strong style={{ color: theme.text }}>{filteredData.length}</strong> mu {uburezi.length}
            </small>
          </div>
        )}
      </div>

      {/* ═══════════ MOBILE FILTER PANEL ═══════════ */}
      {isMobile && (
        <>
          <div className="mobile-filter-overlay" onClick={() => setShowMobileFilters(false)} />
          <div className="mobile-filter-panel">
            <div style={{ width: "36px", height: "4px", background: theme.borderLight, borderRadius: "2px", margin: "0 auto 1rem" }} />
            <h6 style={{ color: theme.textBright, fontWeight: 700, marginBottom: "0.85rem", fontSize: "0.93rem" }}>
              <i className="bi bi-funnel me-2"></i>Amahitamo
            </h6>
            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ color: theme.muted, fontSize: "0.73rem", fontWeight: 600, marginBottom: "0.4rem", display: "block" }}>
                Urwego rw'Amashuri
              </label>
              <div className="d-flex gap-2 flex-wrap">
                {[{ val: "all", label: "Byose" }, ...educationLevels.map(l => ({ val: l.value, label: l.label }))].map(opt => (
                  <button key={opt.val} onClick={() => setFilterLevel(opt.val)} style={{
                    borderRadius: "10px", minHeight: "36px",
                    border: `1px solid ${filterLevel === opt.val ? theme.primary : theme.borderLight}`,
                    background: filterLevel === opt.val ? `${theme.primary}22` : "transparent",
                    color: filterLevel === opt.val ? theme.primary : theme.muted,
                    padding: "0.3rem 0.7rem", fontSize: "0.75rem", fontWeight: 600, cursor: "pointer",
                    WebkitTapHighlightColor: "transparent",
                  }}>{opt.label}</button>
                ))}
              </div>
            </div>
            <div className="d-flex gap-2">
              <button onClick={clearFilters} className="flex-fill" style={{
                background: "transparent", border: `1px solid ${theme.borderLight}`,
                borderRadius: "12px", color: theme.muted, minHeight: "44px", cursor: "pointer",
                fontWeight: 600, WebkitTapHighlightColor: "transparent",
              }}>
                <i className="bi bi-x-lg me-1"></i>Siba
              </button>
              <button onClick={() => setShowMobileFilters(false)} className="flex-fill" style={{
                background: theme.primary, border: "none", borderRadius: "12px",
                color: "#fff", minHeight: "44px", cursor: "pointer", fontWeight: 600,
                WebkitTapHighlightColor: "transparent",
              }}>
                <i className="bi bi-check-lg me-1"></i>Emeza
              </button>
            </div>
          </div>
        </>
      )}

      {/* ═══════════ DATA ═══════════ */}
      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" style={{ color: theme.primary, width: isSmall ? "2rem" : "3rem", height: isSmall ? "2rem" : "3rem" }} />
          <p className="mt-3" style={{ color: theme.muted, fontSize: isSmall ? "0.78rem" : "0.88rem" }}>Gutegereza...</p>
        </div>
      ) : current.length === 0 ? (
        <div className="text-center" style={{
          background: theme.card, borderRadius: isSmall ? "14px" : "20px",
          border: `1px solid ${theme.border}`, padding: isSmall ? "2rem 0.75rem" : "3rem",
        }}>
          <i className="bi bi-mortarboard" style={{ fontSize: isSmall ? "2.5rem" : "5rem", color: theme.border }}></i>
          <h4 className="mt-3" style={{ color: theme.muted, fontSize: isSmall ? "0.95rem" : "1.15rem" }}>
            {searchTerm || activeFilterCount > 0 ? "Nta bisubizo" : "Nta makuru y'uburezi ahari"}
          </h4>
          {(searchTerm || activeFilterCount > 0) && (
            <button onClick={clearFilters} style={{
              background: `${theme.primary}22`, border: `1px solid ${theme.primary}44`,
              borderRadius: "10px", color: theme.primary, padding: "0.4rem 1rem",
              cursor: "pointer", marginTop: "0.5rem", fontSize: "0.8rem", fontWeight: 600,
            }}>
              <i className="bi bi-x-lg me-1"></i>Siba amahitamo
            </button>
          )}
        </div>
      ) : (
        <>
          {isMobile && useCardView ? (
            <div>
              <div style={{ fontSize: "0.6rem", color: theme.muted, marginBottom: "0.35rem", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600 }}>
                {filteredData.length} abaturage
              </div>
              {current.map((item, idx) => renderMobileCard(item, idx))}
            </div>
          ) : (
            <div style={{
              background: theme.card, borderRadius: isSmall ? "12px" : "20px",
              border: `1px solid ${theme.border}`, overflow: "hidden",
              boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
            }}>
              <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch", overscrollBehaviorX: "contain" }}>
                <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
                  <thead>
                    <tr>
                      {["#", "Amazina", "Urwego", "Umwuga", "Ishuri", "Ibikorwa"].map((h, idx) => (
                        <th key={idx} style={{
                          background: `linear-gradient(180deg, ${theme.primary} 0%, #093278 100%)`,
                          color: "rgba(255,255,255,0.85)", fontWeight: 700, textTransform: "uppercase",
                          letterSpacing: "0.06em",
                          fontSize: isTablet ? "0.63rem" : "0.7rem",
                          padding: isTablet ? "0.8rem 0.6rem" : "1rem 1rem",
                          borderBottom: `2px solid ${theme.borderLight}`,
                          textAlign: idx === 0 || idx === 5 ? "center" : "left",
                          whiteSpace: "nowrap", position: "sticky", top: 0, zIndex: 1,
                          minWidth: idx === 1 ? "150px" : idx === 5 ? "120px" : "auto",
                        }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {current.map((item, i) => {
                      const level = getLevelConfig(item.urwego_rw_amashuri);
                      const lColor = getLevelColor(level.color);
                      const lBg = getLevelBg(level.color);
                      return (
                        <tr key={item.uburezi_id} style={{ borderBottom: `1px solid ${theme.border}` }}>
                          <td style={{ padding: "0.85rem", textAlign: "center", borderBottom: `1px solid ${theme.border}` }}>
                            <span style={{
                              display: "inline-flex", alignItems: "center", justifyContent: "center",
                              width: "28px", height: "28px", borderRadius: "8px",
                              background: "rgba(108,99,255,0.1)", color: theme.primary,
                              fontSize: "0.75rem", fontWeight: 700,
                            }}>{idxFirst + i + 1}</span>
                          </td>
                          <td style={{ padding: "0.85rem", borderBottom: `1px solid ${theme.border}`, color: theme.textBright, fontWeight: 600, fontSize: "0.88rem" }}>
                            <div className="d-flex align-items-center gap-2">
                              <div style={{
                                width: "32px", height: "32px", borderRadius: "8px",
                                background: `${theme.primary}22`, display: "flex",
                                alignItems: "center", justifyContent: "center", flexShrink: 0,
                              }}>
                                <i className="bi bi-person-fill" style={{ color: theme.primary, fontSize: "0.85rem" }}></i>
                              </div>
                              <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {item.amazina_y_umuturage}
                              </span>
                            </div>
                          </td>
                          <td style={{ padding: "0.85rem", borderBottom: `1px solid ${theme.border}` }}>
                            <span style={{
                              display: "inline-flex", alignItems: "center", gap: "0.3rem",
                              padding: "0.3rem 0.7rem", borderRadius: "16px",
                              fontSize: "0.75rem", fontWeight: 600,
                              color: lColor, background: lBg,
                              border: `1px solid ${lColor}33`,
                            }}>
                              <i className={`bi bi-${level.icon}`}></i>
                              {item.urwego_rw_amashuri}
                            </span>
                          </td>
                          <td style={{ padding: "0.85rem", borderBottom: `1px solid ${theme.border}`, color: item.umwuga ? theme.text : theme.muted, fontSize: "0.85rem" }}>
                            {item.umwuga || "—"}
                          </td>
                          <td style={{ padding: "0.85rem", borderBottom: `1px solid ${theme.border}`, color: item.ishuri_yizemo ? theme.text : theme.muted, fontSize: "0.85rem" }}>
                            {item.ishuri_yizemo || "—"}
                          </td>
                          <td style={{ padding: "0.85rem", borderBottom: `1px solid ${theme.border}`, textAlign: "center" }}>
                            <div className="d-flex gap-1 justify-content-center">
                              {[
                                { icon: "eye", color: theme.info, bc: "rgba(0,149,255,0.3)", bg: "rgba(0,149,255,0.08)", action: () => handleViewDetails(item) },
                                { icon: "pencil", color: theme.primary, bc: "rgba(108,99,255,0.3)", bg: "rgba(108,99,255,0.08)", action: () => handleEdit(item) },
                                { icon: "trash", color: theme.danger, bc: "rgba(255,61,113,0.3)", bg: "rgba(255,61,113,0.08)", action: () => handleDeleteClick(item) },
                              ].map((btn, idx) => (
                                <button key={idx} onClick={btn.action} style={{
                                  width: isTablet ? "30px" : "34px", height: isTablet ? "30px" : "34px",
                                  borderRadius: "10px", border: `1px solid ${btn.bc}`,
                                  background: btn.bg, color: btn.color,
                                  display: "flex", alignItems: "center", justifyContent: "center",
                                  cursor: "pointer", fontSize: "0.82rem",
                                  WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
                                }}>
                                  <i className={`bi bi-${btn.icon}`}></i>
                                </button>
                              ))}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {renderPagination()}
        </>
      )}

      {/* ═══════════ DELETE MODAL ═══════════ */}
      <Modal show={showDeleteModal} onHide={() => !deleting && setShowDeleteModal(false)} centered size={isSmall ? "sm" : undefined}>
        <div style={{ background: theme.card, borderRadius: "20px", border: `1px solid ${theme.border}`, overflow: "hidden" }}>
          <div style={{ padding: isSmall ? "1.25rem" : "2rem", textAlign: "center" }}>
            <div style={{
              width: isSmall ? "60px" : "75px", height: isSmall ? "60px" : "75px",
              borderRadius: "50%", background: "rgba(255,61,113,0.1)",
              border: `3px solid ${theme.danger}`, display: "flex",
              alignItems: "center", justifyContent: "center",
              margin: "0 auto 1rem", animation: "pulse-danger 2s infinite",
            }}>
              <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: isSmall ? "1.5rem" : "2rem", color: theme.danger }}></i>
            </div>
            <h5 style={{ color: theme.textBright, fontWeight: 700, marginBottom: "0.5rem", fontSize: isSmall ? "1rem" : "1.15rem" }}>
              Gusiba Amakuru
            </h5>
            {deleteTarget && (
              <div style={{
                background: "rgba(255,61,113,0.08)", border: `1px solid rgba(255,61,113,0.2)`,
                borderRadius: "12px", padding: "0.6rem", marginBottom: "0.6rem",
              }}>
                <strong style={{ color: theme.textBright, fontSize: isSmall ? "0.88rem" : "1rem" }}>
                  {deleteTarget.amazina_y_umuturage}
                </strong>
              </div>
            )}
            <div style={{
              background: "rgba(255,170,0,0.08)", border: `1px solid rgba(255,170,0,0.2)`,
              borderRadius: "10px", padding: "0.4rem 0.75rem", marginBottom: "1rem",
            }}>
              <p style={{ color: theme.warning, fontSize: isSmall ? "0.7rem" : "0.78rem", margin: 0, fontWeight: 600 }}>
                <i className="bi bi-exclamation-circle me-1"></i>
                Ntishobora gusubizwaho!
              </p>
            </div>
            <div className="d-flex gap-2">
              <button onClick={() => setShowDeleteModal(false)} disabled={deleting} className="flex-fill" style={{
                background: "transparent", border: `1px solid ${theme.borderLight}`,
                borderRadius: "12px", color: theme.muted, padding: "0.5rem",
                fontWeight: 600, cursor: deleting ? "not-allowed" : "pointer",
                fontSize: isSmall ? "0.78rem" : "0.88rem", minHeight: isMobile ? "44px" : "auto",
              }}>
                <i className="bi bi-x-circle me-1"></i>Oya
              </button>
              <button onClick={confirmDelete} disabled={deleting} className="flex-fill" style={{
                background: `linear-gradient(135deg, ${theme.danger}, #cc3160)`,
                border: "none", borderRadius: "12px", color: "#fff", padding: "0.5rem",
                fontWeight: 700, cursor: deleting ? "not-allowed" : "pointer",
                fontSize: isSmall ? "0.78rem" : "0.88rem", minHeight: isMobile ? "44px" : "auto",
                boxShadow: `0 4px 15px ${theme.dangerGlow}`, opacity: deleting ? 0.7 : 1,
              }}>
                {deleting ? <><Spinner size="sm" className="me-1" />Gusiba...</> : <><i className="bi bi-trash me-1"></i>Yego, Siba</>}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* ═══════════ ADD/EDIT MODAL ═══════════ */}
      <Modal show={show} onHide={() => setShow(false)} size={isMobile ? undefined : "lg"} centered fullscreen={isSmall ? true : undefined}>
        <Modal.Header closeButton style={{
          background: `linear-gradient(135deg, ${theme.primary} 0%, #4f46e5 100%)`,
          color: "white", border: "none",
        }}>
          <Modal.Title style={{ fontWeight: 700 }}>
            <i className={`bi ${editing ? "bi-pencil-square" : "bi-plus-circle"} me-2`}></i>
            {editing ? (isSmall ? "Hindura" : "Hindura Amakuru") : (isSmall ? "Ongeraho" : "Ongeraho Amakuru")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: theme.bg }}>
          <Form onSubmit={handleSubmit}>
            <Row className="g-3">
              <Col xs={12}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Amazina <span style={{ color: theme.danger }}>*</span></Form.Label>
                  <InputGroup>
                    <InputGroup.Text style={{ borderRadius: "12px 0 0 12px" }}><i className="bi bi-person"></i></InputGroup.Text>
                    <Form.Control name="amazina_y_umuturage" value={form.amazina_y_umuturage}
                      onChange={handleChange} placeholder="Amazina yombi" isInvalid={!!formErrors.amazina_y_umuturage}
                      style={{ borderRadius: "0 12px 12px 0" }} autoComplete="name" />
                    <Form.Control.Feedback type="invalid">{formErrors.amazina_y_umuturage}</Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Urwego <span style={{ color: theme.danger }}>*</span></Form.Label>
                  <InputGroup>
                    <InputGroup.Text style={{ borderRadius: "12px 0 0 12px" }}><i className="bi bi-mortarboard"></i></InputGroup.Text>
                    <Form.Select name="urwego_rw_amashuri" value={form.urwego_rw_amashuri}
                      onChange={handleChange} isInvalid={!!formErrors.urwego_rw_amashuri}
                      style={{ borderRadius: "0 12px 12px 0" }}>
                      <option value="">Hitamo urwego...</option>
                      {educationLevels.map(l => <option key={l.value} value={l.value}>{l.label}</option>)}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">{formErrors.urwego_rw_amashuri}</Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Umwuga</Form.Label>
                  <InputGroup>
                    <InputGroup.Text style={{ borderRadius: "12px 0 0 12px" }}><i className="bi bi-briefcase"></i></InputGroup.Text>
                    <Form.Control name="umwuga" value={form.umwuga} onChange={handleChange}
                      placeholder="Nk'umwalimu, umuganga..." style={{ borderRadius: "0 12px 12px 0" }} />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Ishuri</Form.Label>
                  <InputGroup>
                    <InputGroup.Text style={{ borderRadius: "12px 0 0 12px" }}><i className="bi bi-building"></i></InputGroup.Text>
                    <Form.Control name="ishuri_yizemo" value={form.ishuri_yizemo} onChange={handleChange}
                      placeholder="Nk'GS Kigali, UR..." style={{ borderRadius: "0 12px 12px 0" }} />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ background: theme.card, borderTop: `1px solid ${theme.border}`, flexDirection: isMobile ? "column" : "row" }}>
          <button type="submit" onClick={handleSubmit} style={{
            background: editing
              ? `linear-gradient(135deg, ${theme.warning}, #e68a00)`
              : `linear-gradient(135deg, ${theme.success}, #00b887)`,
            border: "none", borderRadius: "12px", color: "#fff",
            padding: "0.5rem 1.2rem", fontWeight: 700,
            boxShadow: editing ? `0 4px 15px ${theme.warningGlow}` : `0 4px 15px ${theme.successGlow}`,
            minHeight: isMobile ? "48px" : "auto", width: isMobile ? "100%" : "auto",
            cursor: "pointer", order: isMobile ? 1 : 2,
            WebkitTapHighlightColor: "transparent",
          }}>
            <i className={`bi me-1 ${editing ? "bi-save" : "bi-check-circle"}`}></i>
            {editing ? "Hindura" : "Bika"}
          </button>
          <button onClick={() => setShow(false)} style={{
            background: "transparent", border: `1px solid ${theme.borderLight}`,
            borderRadius: "12px", color: theme.muted, padding: "0.5rem 1.2rem", fontWeight: 600,
            minHeight: isMobile ? "44px" : "auto", width: isMobile ? "100%" : "auto",
            cursor: "pointer", order: isMobile ? 2 : 1,
          }}>
            <i className="bi bi-x-circle me-1"></i>Funga
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════ DETAILS MODAL ═══════════ */}
      <Modal show={showDetails} onHide={() => setShowDetails(false)} centered size={isMobile ? undefined : "lg"}
        fullscreen={isSmall ? true : undefined}>
        <Modal.Header closeButton style={{
          background: `linear-gradient(135deg, ${theme.info} 0%, #0077cc 100%)`,
          color: "white", border: "none",
        }}>
          <Modal.Title style={{ fontWeight: 700 }}>
            <i className="bi bi-eye me-2"></i>{isSmall ? "Amakuru" : "Amakuru Arambuye"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: theme.bg }}>
          {selectedItem && (
            <div>
              {/* Header Card */}
              <div style={{
                background: theme.card, borderRadius: "16px", padding: isSmall ? "1rem" : "1.5rem",
                textAlign: "center", border: `1px solid ${theme.border}`, marginBottom: "1rem",
              }}>
                <div style={{
                  width: isSmall ? "50px" : "70px", height: isSmall ? "50px" : "70px",
                  borderRadius: isSmall ? "14px" : "18px",
                  background: `${theme.primary}22`, display: "flex",
                  alignItems: "center", justifyContent: "center",
                  margin: "0 auto 0.75rem",
                }}>
                  <i className="bi bi-person-fill" style={{ fontSize: isSmall ? "1.5rem" : "2.2rem", color: theme.primary }}></i>
                </div>
                <h4 className="fw-bold mb-2" style={{ color: theme.textBright, fontSize: isSmall ? "1rem" : "1.3rem" }}>
                  {selectedItem.amazina_y_umuturage}
                </h4>
                <span style={{
                  display: "inline-flex", alignItems: "center", gap: "0.4rem",
                  padding: "0.35rem 1rem", borderRadius: "20px",
                  fontSize: isSmall ? "0.8rem" : "0.9rem", fontWeight: 700,
                  color: getLevelColor(getLevelConfig(selectedItem.urwego_rw_amashuri).color),
                  background: getLevelBg(getLevelConfig(selectedItem.urwego_rw_amashuri).color),
                }}>
                  <i className={`bi bi-${getLevelConfig(selectedItem.urwego_rw_amashuri).icon}`}></i>
                  {selectedItem.urwego_rw_amashuri}
                </span>
              </div>

              {/* Details Grid */}
              <div style={{ display: "grid", gridTemplateColumns: isSmall ? "1fr" : "1fr 1fr", gap: "0.75rem" }}>
                {[
                  { label: "Umwuga", value: selectedItem.umwuga, icon: "briefcase", color: theme.warning },
                  { label: "Ishuri Yizemo", value: selectedItem.ishuri_yizemo, icon: "building", color: theme.info },
                ].map((item, i) => (
                  <div key={i} style={{
                    background: theme.card, borderRadius: "14px", padding: "1rem",
                    border: `1px solid ${theme.border}`, borderLeft: `4px solid ${item.color}`,
                  }}>
                    <small style={{ color: theme.muted, display: "block", marginBottom: "0.35rem", fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.05em", fontWeight: 600 }}>
                      {item.label}
                    </small>
                    <div style={{ color: item.value ? theme.textBright : theme.muted, fontWeight: 600, fontSize: isSmall ? "0.88rem" : "1rem" }}>
                      {item.value ? (
                        <><i className={`bi bi-${item.icon} me-2`} style={{ color: item.color }}></i>{item.value}</>
                      ) : "—"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ background: theme.card, borderTop: `1px solid ${theme.border}`, flexDirection: isMobile ? "column" : "row" }}>
          {selectedItem && (
            <button onClick={() => { setShowDetails(false); handleEdit(selectedItem); }} style={{
              background: theme.primary, border: "none", borderRadius: "12px",
              color: "#fff", padding: "0.5rem 1.2rem", fontWeight: 600,
              boxShadow: `0 4px 15px ${theme.primaryGlow}`,
              minHeight: isMobile ? "44px" : "auto", width: isMobile ? "100%" : "auto",
              cursor: "pointer", WebkitTapHighlightColor: "transparent",
            }}>
              <i className="bi bi-pencil-square me-1"></i>Hindura
            </button>
          )}
          <button onClick={() => setShowDetails(false)} style={{
            background: "transparent", border: `1px solid ${theme.borderLight}`,
            borderRadius: "12px", color: theme.muted, padding: "0.5rem 1.2rem", fontWeight: 600,
            minHeight: isMobile ? "44px" : "auto", width: isMobile ? "100%" : "auto",
            cursor: "pointer", WebkitTapHighlightColor: "transparent",
          }}>
            <i className="bi bi-x-circle me-1"></i>Funga
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Uburezi;